import React from 'react';

const ShellRimulaTheme = {
  headerLogo: {
    src: '/themes/theme/shellrimula/logo.svg',
    alt: 'ShellRimula Logo',
  },
  darkLogo: {
    src: '/themes/theme/shellrimula/logo.svg',
    alt: 'ShellRimula Logo',
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '2px solid #e5001d',
  },
  linkStyle: {
    color: '#e5001d',
    fontWeight: 800,
    fontSize: '120%',
  },
  organisationId: '700c1e32-5994-45fc-865f-1d49b8b338b3',
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img height="50" src="/themes/theme/shellrimula/logo.svg" alt="Shell Rimula Logo" />
      <br /><br />
    </div>
  ),
  shareSite: 'https://shellreports.msqpartners.com',
  copy: {
    joinTitle:
     'Join the Travlrr Influencer Network today',

    joinDescription: (
      <span>
           We offer you the opportunity to collaborate with global travel brands, on new and exciting briefs.
        <br />
           We just ask that you sign-in with instagram, so we can verify who you are!
      </span>
    ),

    featureList: (
      <div>
        <h4>Get paid to produce content for the brands you love:</h4>
        <ul>
          <li>Join our exclusive travel and lifestyle influencer network</li>
          <li>Get recommended to our clients and receive new briefs direct from the Travlrr team</li>
          <li>You choose the campaigns that you want to work on</li>
          <li>We believe influencers should create and be creative</li>
          <li>No joining fees! We will only deduct our commission when you get paid</li>
        </ul>
      </div>
    ),

    applicationFormInstructions: (
      <div>
        <p>Please fill in this short form to complete your application.</p>
        <br />
        <p>
          The Travlrr Influencer Network is free to join,
           no contracts and your data is not shared without your permission
        </p>
        <br />
        <p>
          All influencer accounts are manually checked
           by our team before gaining access to the platform, we’ll be in touch soon.
        </p>
      </div>
    ),
  },
  influencerTermsAndConditionsLink: 'https://www.travlrr.co/influencer-network-terms-conditions',
};

export default ShellRimulaTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/shellrimula.js
 **/